module.exports = __webpack_public_path__ + "img/gateway.ad713005.svg";